<template>
    <div class="slide-date-filter custom-date-position">
        <div class="date-alignment">Date</div>
        <custom-date-range-picker
            :opens="opens"
            :selected-date="selectedDateRange"
            @apply="onDateChange"
        />
    </div>
</template>

<script>
import CustomDateRangePicker from '../common/CustomDateRangePicker'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    name: 'SlideDateFilter',
    components: { CustomDateRangePicker },
    props: {
        opens: {
            type: String,
            default: 'right'
        }
    },
    computed: {
        ...mapState({
            pastSlideFilter: state => state.timelapse.pastSlideFilter
        }),
        selectedDateRange() {
            if (
                this.pastSlideFilter &&
                this.pastSlideFilter.dateRange &&
                this.pastSlideFilter.dateRange.startDate &&
                this.pastSlideFilter.dateRange.endDate
            ) {
                return {
                    startDate: new Date(this.pastSlideFilter.dateRange.startDate),
                    endDate: new Date(this.pastSlideFilter.dateRange.endDate)
                }
            } else return null
        }
    },
    methods: {
        onDateChange(dateRange) {
            this.$store.commit('timelapse/setPastSlideFilter', {
                dateRange: {
                    startDate: this.getDateInApiFormat(dateRange.startDate),
                    endDate: this.getDateInApiFormat(dateRange.endDate)
                }
            })
            this.$store.dispatch('timelapse/setPastSlides')
        },
        getDateInApiFormat(date) {
            const format = 'YYYY-MM-DD'
            if (moment(date, format, true).isValid()) return moment(date).format(format)
            return null
        }
    }
}
</script>

<style lang="scss">
.slide-date-filter {
    width: 100%;
    max-width: 1344px;
    margin: 0 auto;
    padding: 2rem 0.5rem 0.5rem;

    .date-alignment {
        margin-bottom: 0.2rem;
    }
    &.filter-heading {
        font-size: 1rem;
        color: $light;
        margin-bottom: 0.5rem;
    }
    &.adjust-margin {
        margin: 1rem 0 1rem 0.4rem;
    }
    .custom-date-position {
        position: fixed;
    }
}
</style>
